// extracted by mini-css-extract-plugin
module.exports = {"fixContainer":"style__fixContainer__D+USv"};